// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JmPp","fullView":"styles_fullView__1vSB3"};